import { BaseControlDrawer } from './BaseControlDrawer';
import { webConfig } from '../../../core/applicationConfig';
import { HISTORY_ICON_STATE, INFO_ICON_STATE, SOUND_ICON_STATE } from '../../../stateManagment';
import { controllerSourceNames } from '../../../core/sourceNames';
import { controlPadSharedResources } from '../../../core/resources';

export class ControlLandscapeDrawer extends BaseControlDrawer {
  constructor() {
    super();
    this.config = {
      w: webConfig.width / 3.3,
      h: 130,
    };
    this.app = this.createApplication({
      width: this.config.w,
      height: this.config.h,
      backgroundAlpha: 0,
    });
    this.container = this.createContainer();
    this.app.stage.addChild(this.container);
    this.loader = this.createLoader();
  }

  async loadResource() {
    if (!this.resources) {
      const { res } = await super.loadResource(controlPadSharedResources, this.loader);
      this.resources = res;
    }
    return this.resources;
  }

  setIcons() {
    const margin = 5;
    const rightAlign = 15;
    const sizes = { w: 70, h: 70 };
    const info = super.getIcon({
      name: controllerSourceNames.infoIconMobile,
      activeIconName: controllerSourceNames.infoIconActive,
      observer: INFO_ICON_STATE,
      sizes,
      onClick: () => {
      },
    });
    const history = super.getIcon({
      name: controllerSourceNames.historyIconMobile,
      activeIconName: controllerSourceNames.historyIconActive,
      observer: HISTORY_ICON_STATE,
      sizes,
      onClick: () => {
      },
    });
    const sound = super.getIcon({
      name: controllerSourceNames.soundOffIconMobile,
      activeIconName: controllerSourceNames.soundOnIcon,
      observer: SOUND_ICON_STATE,
      sizes,
      onClick: () => {
      },
    });
    const space = this.config.w - (rightAlign + 2 * margin + 3 * sizes.w);
    [info, history, sound].forEach((texture, index) => {
      this.setPosition(texture, { x: space + index * (sizes.w + margin), y: 50 });
      this.container.addChild(texture);
    });
  }

  execute(root) {
    this.loadResource().then(() => {
      this.setIcons();
      root.append(this.app.view);
    });
  }
}
